import { Button, Dialog, DialogActions, DialogContent, DialogTitle, FormControlLabel, Radio, RadioGroup, TextField, CircularProgress, Snackbar } from '@material-ui/core';
import SendIcon from '@material-ui/icons/Send';
import React, { useState } from 'react';
import axios from 'src/utils/axios'
import Alert from 'src/components/Alert';
import { loadBaslandiJob, saveBaslandiJob } from 'src/utils/storage/StartWorkOrder';
import CloseIcon from '@material-ui/icons/Close';
import logger from 'src/utils/logger';

function KocailemVerification({ open, setOpen, FisNo, setTutar, alertMessage }) {

  const [queryType, setQueryType] = useState("1");
  const [queryTypeText, setQueryTypeText] = useState("TC No");
  const [queryNo, setQueryNo] = useState('');
  const [loading, setLoading] = useState(false);
  const [verified, setVerified] = useState(false);
  const [uyariOpen, setUyariOpen] = useState(false);
  const [uyariTip, setUyariTip] = useState('success');
  const [uyariAciklama, setUyariAciklama] = useState('');
  const [smsCode, setSmsCode] = useState('');

  const handleChangeQueryType = (e) => {
    setQueryTypeText(e.target.name);
    setQueryType(e.target.value);
    setQueryNo('');
  }

  const handleVerifyMembership = () => {
    if (queryNo.length === 0) {
      setUyariTip('error');
      setUyariAciklama(queryTypeText + ' alanı boş bırakılamaz!..');
      setUyariOpen(true);
      return;
    }
    setLoading(true);
    axios.get(`/GetKocailemMembership/${FisNo}/${queryType}/${queryNo}`)
      .then(response => {
        if (parseInt(response.data?.ErrorCode) === 0) {
          setUyariTip('success');
          setUyariAciklama(response.data?.ErrorDescription || 'İşlem Başarılı');
          setUyariOpen(true);
          setVerified(true);
        } else {
          setUyariTip('error');
          setUyariAciklama(response.data?.ErrorDescription || 'Bir hata oluştu!..');
          setUyariOpen(true);
          setVerified(false);
        }
        setLoading(false);
      }).catch(error => {
        setUyariTip('error');
        setUyariAciklama('Bir hata oluştu!..');
        setUyariOpen(true);
        setVerified(false);
        setLoading(false);
        logger.error("Hata detayı:", error.message);
      });
  }

  const handleVerifySmsCode = () => {
    if(smsCode.length !== 4){
      setUyariTip('error');
      setUyariAciklama('Sms kodunu 4 hane şeklinde giriniz!..');
      setUyariOpen(true);
      return;
    }
    setLoading(true);
    let job = loadBaslandiJob()[0];
    let labour = job.ISCILIK_TOPLAM || 0;
    let material = job.MALZEME_TOPLAM || 0;
    axios.get(`/GetKocailemVerifySms/${FisNo}/${smsCode}/${labour}/${material}`)
      .then(response => {
        if (response.data?.ISLEM === 1) {
          let job = loadBaslandiJob()[0];
          job = {
            ...job,
            KOCAILEM: 1,
            INDIRIMLI_TUTAR_KDVLI: parseFloat(response.data.KALAN_TUTAR)
          }
          saveBaslandiJob(job);
          setTutar(parseFloat(response.data.KALAN_TUTAR) || 0);
          alertMessage('success', `Sms doğrulaması başarılı. ${response.data.KDVLI_TOPLAM}₺ işlem üzerinden ${response.data.INDIRIM_TUTARI}₺ indirim uygulandı.`);
          setOpen(false);
        } else {
          setUyariTip('error');
          setUyariAciklama('Sms kodu uyuşmuyor!..');
          setUyariOpen(true);
        }
        setLoading(false);
      }).catch(error => {
        setUyariTip('error');
        setUyariAciklama('Bir hata oluştu!..');
        setUyariOpen(true);
        setLoading(false);
        logger.error("Hata detayı:", error.message);
      });
  }

  const uyariKapat = (event, reason) => {
    if (reason === 'clickaway') {
      return;
    }
    setUyariOpen(false);
  };


  return (
    <Dialog
      open={open}
      onClose={() => setOpen(false)}
      fullWidth
    >
      <DialogTitle color="primary">{"KoçAilem Müşteri Doğrulaması"}</DialogTitle>
      <DialogContent>
        <Snackbar open={uyariOpen}
          autoHideDuration={10000}
          onClose={uyariKapat}>
          <Alert onClose={uyariKapat} message={uyariAciklama} variant={uyariTip} />
        </Snackbar>
        {loading && <CircularProgress
          status={'loading'}
          style={{ marginLeft: '50%' }}
        />}
        {!verified ?
          <div>
            <RadioGroup value={queryType} onChange={(e) => handleChangeQueryType(e)}>
              <FormControlLabel name="TC No" value="1" control={<Radio />} label="TC No" />
              <FormControlLabel name="KoçAilem No" value="3" control={<Radio />} label="KoçAilem No" />
                <FormControlLabel name="Telefon No" value="5" control={<Radio />} label="Telefon No" />
            </RadioGroup>
            <TextField
              label={queryTypeText}
              fullWidth
              value={queryNo}
              onChange={(e) => setQueryNo(e.target.value)}
              variant="outlined" />
            <br />
            <br />
            <Button onClick={() => handleVerifyMembership()} disabled={loading} color="secondary" variant="contained" endIcon={<SendIcon />}>
              Sms Gönder
          </Button>
          </div>
          :
          <div>
            <TextField
              label="Sms Kodu"
              fullWidth
              value={smsCode}
              onChange={(e) => setSmsCode(e.target.value)}
              variant="outlined" />
            <br />
            <br />
            <Button onClick={() => handleVerifySmsCode()} disabled={loading} color="secondary" variant="contained" endIcon={<SendIcon />}>
              Sms Doğrula
          </Button>
          </div>
        }
      </DialogContent>
      <DialogActions>
        <Button onClick={() => setOpen(false)}
        endIcon={<CloseIcon>Close</CloseIcon>}
        color="primary">
          Kapat
          </Button>
      </DialogActions>
    </Dialog>
  );
}

export default KocailemVerification;
